import styled from 'styled-components';

import Button from '@prisjakt/ui-button';

import RichText from '../rich-text';

type ListProps = {};

export const List = styled.section<ListProps>``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CompareButton = styled(Button)`
  color: ${p => p.theme.text.callToAction};
`;

export const Title = styled(RichText)`
  margin-bottom: 0;
  font-size: 1rem;

  h2 {
    font-size: 1rem;
  }
`;
